import { Stack } from '@mui/material';
import SingleReactHookFormWrapper from 'Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper';
import React, { useContext, useState } from 'react';
import useCreateComplexField from 'Global/Hooks/useCreateComplexField';
import AccordionGeneral from 'Global/Components/CommonComponents/AccordionGeneral/AccordionGeneral';
import SubmitButton from 'Global/Components/UnEditableComponents/SubmitButton/SubmitButton';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { SubmitFn } from './functions/SubmitFn';
import SettingElementCreator from '../SettingElementCreator';
import EditLanguageList from './EditLanguageList';
import { SortMarkazFn } from './functions/SortMarkazFn';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import LanguageEditor from '../../../LanguageEditor/LanguageEditor';
import { labels } from './variables/labels';

const WebAppSettings = () => {
  const [showLangEditor, setShowLangEditor] =
    useState(false);

  const isLanguageEditAllowed = true;

  const GlobalConstants = useContext(GlobalContext);
  const AccessRoles = GlobalConstants?.AccessRoles;
  const label_web_app_settings = FindLangKey(
    'genral-public-label-wep-app-settings'
  );
  const edit_lang_msg = FindLangKey(
    'personalization-drawer-label-edit-language'
  );
  const submit_label = FindLangKey(
    'general-public-btn-save'
  );
  const confirm_msg = FindLangKey(
    'main-menu-drawer-confirm-message'
  );

  const languageSelector_msg = FindLangKey(
    'general-public-setting-language'
  );
  const close_lang_editor = FindLangKey(
    'general-public-not-found-return'
  );

  const markazSettings =
    useContext(GlobalContext)?.appConfig;

  const CheckBoxTopSettings = SortMarkazFn(markazSettings);

  const { fields, control, formState, handleSubmit } =
    useCreateComplexField(
      `markazSettings`,
      CheckBoxTopSettings
    );

  const fieldKeys = fields?.map((el) => el.Key);
  const labelArray = labels();

  console.log('fields--->',fields)


 
  return (
    <React.Fragment>
      {showLangEditor ? (
        isLanguageEditAllowed ? (
          <LanguageEditor
            setShowLangEditor={setShowLangEditor}
            closeEdtiorLabel={close_lang_editor}
          />
        ) : (
          <></>
        )
      ) : (
        <form
          onSubmit={handleSubmit((data) => {
            SubmitFn(data, confirm_msg);
            // console.log("the data is ->", data);
          })}
          style={{
            marginBlock: '1em',
            paddingInline: '1em',
          }}
        >
          <Stack gap=".5em">
            {fields
              ?.filter((fl) => fieldKeys.includes(fl.Key))
              ?.map((field, index) => (
                <SingleReactHookFormWrapper
                  key={field.id}
                  name={`markazSettings[${index}].Value`}
                  control={control}
                  errors={formState.errors}
                  element={
                    <SettingElementCreator
                      field={field}
                      index={index}
                      languageSelector_msg={
                        languageSelector_msg
                      }
                      labelArray={labelArray}
                    />
                  }
                />
              ))}

            <EditLanguageList
              setShowLangEditor={setShowLangEditor}
              isLanguageEditAllowed={isLanguageEditAllowed}
              AccessRoles={AccessRoles}
              edit_lang_msg={edit_lang_msg}
            />
            <SubmitButton
              label={submit_label}
              height={'unset'}
            />
          </Stack>
        </form>
      )}

      {/* <GeneralAppSettings fields={fields} /> */}
    </React.Fragment>
  );
};

export default WebAppSettings;

// TypeChecker(
//   markazSettings,
//   languages,
//   field.Key,
//   labelArray,
//   index,
//   selectIconLabel
// )
